module.exports = __webpack_public_path__ + "media/images/android-icon-192x192-0f78b9a30f217967fcf0f56de896bf89.png";